import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useState } from "react";
import BookingListTable from "./BookingListTable"; // Import the reusable component

interface GroupedBookingsTableProps {
  groupKey: string;
  groupLabel: string;
  bookings: any[];
  visibleColumns: readonly any[];
  isMobile: boolean;
  onRowClick: (row: any) => void;
  getStatusColor: (status: string) => string;
}

const GroupedBookingsTable = ({
  groupLabel,
  bookings,
  visibleColumns,
  isMobile,
  onRowClick,
  getStatusColor,
}: GroupedBookingsTableProps) => {
  const [page, setPage] = useState(1);

  const handlePageChange = (
    event: React.ChangeEvent<unknown> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        sx={{
          backgroundColor: "#FAFAFA",
          borderBottom: "1px solid #EAEAEA",
          "& .MuiAccordionSummary-content": {
            alignItems: "center",
            gap: 1,
          },
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 500, color: "#535862" }}>
          {groupLabel}
        </Typography>
        <Chip
          label={bookings.length}
          size="small"
          variant="outlined"
          sx={{
            height: 20,
            fontSize: "0.75rem",
          }}
        />
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        {/* Reusing the optimized table component */}
        <BookingListTable 
          bookings={bookings}
          visibleColumns={visibleColumns}
          isMobile={isMobile}
          onRowClick={onRowClick}
          getStatusColor={getStatusColor}
          page={page}
          onPageChange={handlePageChange}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default GroupedBookingsTable;